"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapGenTile = exports.RNGItemType = void 0;
var RNGItemType;
(function (RNGItemType) {
    RNGItemType["Armor"] = "Armor";
    RNGItemType["Weapon"] = "Weapon";
    RNGItemType["Jewelry"] = "Jewelry";
    RNGItemType["Caster"] = "Caster";
    RNGItemType["Offensive"] = "Offensive";
    RNGItemType["Defensive"] = "Defensive";
    RNGItemType["Sharp"] = "Sharp";
    RNGItemType["Blunt"] = "Blunt";
    RNGItemType["Cloth"] = "Cloth";
    RNGItemType["Metal"] = "Metal";
    RNGItemType["Wood"] = "Wood";
    RNGItemType["OneHanded"] = "OneHanded";
    RNGItemType["TwoHanded"] = "TwoHanded";
    RNGItemType["Ranged"] = "Ranged";
    RNGItemType["Small"] = "Small";
    RNGItemType["Medium"] = "Medium";
    RNGItemType["Large"] = "Large";
})(RNGItemType || (exports.RNGItemType = RNGItemType = {}));
var MapGenTile;
(function (MapGenTile) {
    MapGenTile[MapGenTile["Empty"] = 0] = "Empty";
    MapGenTile[MapGenTile["Wall"] = 1] = "Wall";
    MapGenTile[MapGenTile["Door"] = 2] = "Door";
    MapGenTile[MapGenTile["DefaultWall"] = 3] = "DefaultWall";
})(MapGenTile || (exports.MapGenTile = MapGenTile = {}));
